import "core-js/modules/es7.promise.finally";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import React from "react";
import { AlertBox, Button } from "@origin-digital/style-guide";
import { Box } from "@origin-digital/layout";
var defaultErrorMessage = "An error occurred";
export var CTAAction =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CTAAction, _React$Component);

  function CTAAction() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CTAAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CTAAction)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      spinner: false,
      error: false
    });

    _defineProperty(_assertThisInitialized(_this), "setSpinner", function (spinner) {
      return _this.setState({
        spinner: spinner
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setError", function (error) {
      return _this.setState({
        error: error
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCtaAction", function () {
      _this.setSpinner(true);

      _this.setError(false);

      var _this$props = _this.props,
          ctaAction = _this$props.ctaAction,
          onSuccess = _this$props.onSuccess;
      ctaAction().then(function () {
        return onSuccess();
      }).catch(function () {
        return _this.setError(true);
      }).finally(function () {
        return _this.setSpinner(false);
      });
    });

    return _this;
  }

  _createClass(CTAAction, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          spinner = _this$state.spinner,
          error = _this$state.error;
      var _this$props2 = this.props,
          label = _this$props2.label,
          kind = _this$props2.kind;
      return React.createElement(React.Fragment, null, React.createElement(Button, {
        "data-id": "next-best-action-button",
        kind: kind,
        onClick: this.handleCtaAction,
        text: label,
        spinner: spinner,
        trackingDisabled: true
      }), error && React.createElement(Box, {
        marginTop: 4
      }, React.createElement(AlertBox, {
        type: "error",
        message: defaultErrorMessage
      })));
    }
  }]);

  return CTAAction;
}(React.Component);